import React from "react";

const Footer = ({ setFooterClose }) => {
  const handleClose = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setFooterClose(true);
    console.log("Footer close clicked"); // For debugging
  };

  return (
    <div className="footer">
      <div className="footerText mb-1 p-2">
        <span>
          <span className="footerImg">💡</span> Note: This application does not
          store any personal data or information. We respect your privacy, and
          no user data is retained on our servers or locally on your device.
        </span>
        <span 
          className="close" 
          onClick={handleClose}
          style={{ cursor: 'pointer', padding: '0 8px', fontWeight: 'bold' }}
        >
          X
        </span>
      </div>
    </div>
  );
};

export default Footer;